
import {
    getBusinessProfilesDoc,
    getQueryBusinessPortalAccessCollection,
    updateBusinessProfilesDoc
} from "@/shared/firebase_utils";
const state = {
    businessProfile: {
        businessName: '',
        generalPhoneNumber: '',
        countryPhoneCode: 'AU',
        countryPhoneCodeNumber: '+61',
        generalContactEmail: '',
        websiteURL: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        country: '',
        postcode: '',
        facebookURL: '',
        instagramURL: '',
        twitterURL: '',
        linkedinURL: '',
        premiereProfileBackgroundImageURL: '',
        premiereProfileLogoImageURL: '',
        premiereProfileBio: '',
        logoFrame: '',
        logoImageURL: '',
        cardCorners: '',
        reverseImageURL:'',
        backgroundImageURL: '',
        imageURLs: [],
        isMultiConnectOnboarded: false,
        multiConnectCredits: 6,
        badgeImageURL: '',
        badgeQRImageURLs: [],
        qrCodeImageURL: ''
       
    },
    businessProfileId: '',
};

const getters = {
    businessProfile: (state) => state.businessProfile,
    selectedBusinessProfileId: (state) => state.businessProfileId,
    mainBusinessAddress: (state) => {
        let address="";
        if (state.businessProfile.addressLine1)
            address += state.businessProfile.addressLine1 + ", ";
        if (state.businessProfile.addressLine2)
            address += state.businessProfile.addressLine2 + ", ";
        if (state.businessProfile.city)
            address += state.businessProfile.city + ", ";
        if (state.businessProfile.state && state.businessProfile.postcode)
            address += state.businessProfile.state + " - " + state.businessProfile.postcode + "";
        if (state.businessProfile.country)
            address += state.businessProfile.country + "";
        return address;
    }
};

const actions = {
    async initializeBusinessProfile({ commit }, businessProfileId) {

        //Read data from firestore
        await getBusinessProfilesDoc(businessProfileId)
        .then((doc)=> {
            commit('setBusinessProfile', doc.data());
            commit('setBusinessProfileId', doc.id);
        })
        .catch((error)=> {
            console.log("Error getting documents: ", error);
        });
    },

    async updateBusinessProfileDetails({ rootState, dispatch }, updatedBusinessProfile) {
        try{

            //Start: Required to check if an update to the users permisssions is required
            const oldBusinessName = Object.is(state.businessProfile.businessName, undefined)? '' : state.businessProfile.businessName;
            const oldCountry = Object.is(state.businessProfile.country, undefined)? '' : state.businessProfile.country;
            const newBusinessName = Object.is(updatedBusinessProfile.businessName, undefined)? '' : updatedBusinessProfile.businessName;
            const newCountry = Object.is(updatedBusinessProfile.country, undefined)? '' : updatedBusinessProfile.country;
            //Start: Required to check if an update to the users permisssions is required
            const businessProfileId = rootState.userProfile.userProfile.businessProfileId;
            //Update the business profile in firebase
            await updateBusinessProfilesDoc(businessProfileId, updatedBusinessProfile);
            await dispatch('initializeBusinessProfile', businessProfileId);
            if((newBusinessName != '' && oldBusinessName != newBusinessName) || ( newCountry!= '' && oldCountry != newCountry)) {
                //The business name or the country has been changed
                dispatch('updateBusinessProfileFieldsInUserPermissions', { businessName: newBusinessName, country: newCountry});
            }
        } catch(error) {
            console.error("Error in updateBusinessProfileDetails: ", error);
        };
    },

    async updateBusinessProfileFieldsInUserPermissions({ rootState }, newValues ) {
        try{
            const newBusinessName = newValues.businessName;
            const newCountry = newValues.country;
            const businessProfileId = rootState.userProfile.userProfile.businessProfileId;
            let response = await getQueryBusinessPortalAccessCollection('businessProfileId', '==', businessProfileId);
            let i = 0;
            for(i = 0; i< response.docs.length; i++) {
                await updateBusinessProfilesDoc(response.docs[i].id, { businessName: newBusinessName, country: newCountry});
            }
            //Update the locally stored permission of the user
            const userPermissions = rootState.userProfile.loggedInUsersPermissions;
            for(i = 0; i< userPermissions.length; i++) {
                if(userPermissions[i].businessProfileId == businessProfileId) {
                    userPermissions[i].businessName = newBusinessName;
                    userPermissions[i].country = newCountry;
                }
            } 
        } catch(error) {
         console.log("Error in updateBusinessProfileFieldsInUserPermissions: ", error);
        }
    },

    onBusinessProfileSnapshot({commit}, documentData){
        commit('setBusinessProfile', documentData);
    },

    
};

const mutations = {
    setBusinessProfile: (state, businessProfile) => {
        state.businessProfile = businessProfile;
    },
    setBusinessProfileId: (state, businessProfileId) => {
        state.businessProfileId = businessProfileId;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}